import Plausible from "plausible-tracker";

export default class ModelMeAIAnalytics {
  private static plausible: ReturnType<typeof Plausible> | null = null;

  static getPlausible() {
    if (ModelMeAIAnalytics.plausible === null) {
      const plausible = Plausible({
        domain: 'modelmeai.com',
        apiHost: 'https://straw.tryonhaulcentral.com',
        trackLocalhost: false,
      })
      plausible.enableAutoPageviews()
      plausible.enableAutoOutboundTracking()

      ModelMeAIAnalytics.plausible = plausible
    }

    return ModelMeAIAnalytics.plausible
  }
}

